"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
const PADDING_MAP = {
    none: "p-0",
    sm: "p-3",
    md: "p-4",
    lg: "p-6",
};
export function Card({ as, padding = "md", className, children, ...props }) {
    const Component = as ?? "section";
    return (_jsx(Component, { className: clsx("app-card", PADDING_MAP[padding], className), ...props, children: children }));
}
export function CardHeader({ className, ...props }) {
    return _jsx("div", { className: clsx("space-y-1", className), ...props });
}
export function CardTitle({ className, ...props }) {
    return _jsx("div", { className: clsx("text-lg font-semibold", className), ...props });
}
export function CardDescription({ className, ...props }) {
    return _jsx("div", { className: clsx("text-sm opacity-70", className), ...props });
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: clsx("space-y-3", className), ...props });
}
export function CardFooter({ className, ...props }) {
    return _jsx("div", { className: clsx("flex items-center justify-between", className), ...props });
}
